import { Injectable, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { InvalidCtlNameObj } from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { CommonUtilityService, AnalyticsService } from 'src/app/shared';

@Injectable({
  providedIn: 'root'
})
export class FormValidationsService {
  public static invalidDataPresentObj: InvalidCtlNameObj;
  public static returnObj: UntypedFormGroup;
  constructor(public el: ElementRef) { }

  public static validateAllFormFields(formGroup: UntypedFormGroup, analyticsService: AnalyticsService) {
    let fieldErrors = []

    if(formGroup.controls && formGroup.controls.beneficiary) {
      (formGroup.controls.beneficiary['controls']).forEach((value,index,array) => {
         let beneficiaryArray = array[index];
         Object.keys(beneficiaryArray['controls']).forEach(field => {
          const control = beneficiaryArray.get(field);
    
          fieldErrors.push(this.get_error(field, control));
          if (control instanceof UntypedFormControl) {
            control.markAsTouched({ onlySelf: true });
          } else if (control instanceof UntypedFormGroup) {
            this.validateAllFormFields(control, analyticsService);
          }
        });
      })
      // Object.keys(formGroup.controls.beneficiary['controls']).forEach(field => {
      //   const control = formGroup.get(field);
  
      //   fieldErrors.push(this.get_error(field, control));
      //   if (control instanceof UntypedFormControl) {
      //     control.markAsTouched({ onlySelf: true });
      //   } else if (control instanceof UntypedFormGroup) {
      //     this.validateAllFormFields(control, analyticsService);
      //   }
      // });
    } else {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);

      fieldErrors.push(this.get_error(field, control));
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control, analyticsService);
      }
    });
  }
    this.analyticsTracker(fieldErrors, analyticsService);
  }

  public static get_error(field: string, control) {
    let fldErrors = [];
    
    if(control.hasError('required')) {
      fldErrors.push(`${field} is required`);
    }
    if(control.hasError('pattern')) {
      fldErrors.push(`${field} format is invalid`);
    }
    if(control.hasError('notValidEmail')) {
      fldErrors.push(`Valid Email is required`);
    }
    
    return fldErrors;
  }

  public static analyticsTracker(errors, analyticsService) {
    let formErrorMessage = "";
    let formErrorCount = 0;
    let actualErrors = [];

    actualErrors = CommonUtilityService.flattenArray(errors);
    formErrorMessage = actualErrors.join(';');
    formErrorCount = actualErrors.length;
    analyticsService.errorAnalyticsTrack(
      {
        formErrorMessage: formErrorMessage, 
        formErrorType: 'Validation Errors', 
        formErrorDetail: '0', 
        formErrorCount: formErrorCount
      }
    )
  }

  public static validateFormField(formGroup: UntypedFormGroup, controlName) {
    const control = formGroup.controls[controlName];
    control.markAsTouched({ onlySelf: true });
  }

  public static validateAllFormForOneCtl(formGroup: UntypedFormGroup, controlName: string) {
    const controlObj = formGroup.controls[controlName];
    if (controlObj) {
      if (controlObj instanceof UntypedFormGroup) {
        Object.keys(controlObj.controls).forEach(ctl => {
          this.validateAllFormForOneCtl(controlObj, ctl)
        });
      }
      else {
        controlObj.markAsTouched({ onlySelf: true });
      }
    }
  }

  public static clearFormErrors(formGroup: UntypedFormGroup) {
    if (formGroup) {
      Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);

        if (control instanceof UntypedFormControl) {
          control.markAsUntouched();
        } else if (control instanceof UntypedFormGroup) {
          this.clearFormErrors(control);
        }
      });
    }
  }

  public static isInvalidDataFoundInForm(parentForm: UntypedFormGroup): InvalidCtlNameObj {
    this.invalidDataPresentObj = null;
    if (parentForm) {
      this.recursiveFunToFindInvalidDataInForm(parentForm);
    }
    return this.invalidDataPresentObj;
  }

  public static recursiveFunToFindInvalidDataInForm(parentForm: UntypedFormGroup): void {
    let invalidDataPresent = false;
    let ctlNameWithInvalidData: string;
    Object.keys(parentForm.controls).forEach(ctlName => {
      const control = parentForm.get(ctlName);
      if (control instanceof UntypedFormControl) {
        let isValuePresent = this.checkIfValueIsPresent(control, ctlName);
        if (isValuePresent && (control.errors) && (!control.errors.required)) {
          invalidDataPresent = true;
          ctlNameWithInvalidData = ctlName;
          this.invalidDataPresentObj = new InvalidCtlNameObj(invalidDataPresent, ctlNameWithInvalidData);
          control.markAsTouched({ onlySelf: true });
        }
      }
      else if (control instanceof UntypedFormGroup) {
        this.recursiveFunToFindInvalidDataInForm(control);
      }
    });
  }

  public static checkIfValueIsPresent(formObj: any, ctlName: string): boolean {
    let valuePresent: boolean = false;
    if (formObj && formObj.value && formObj.controls) {
      let temp = formObj.controls;
      for (let item in temp) {
        if (temp[item] && temp[item].value) {
          valuePresent = true;
          break;
        }
      }

    }
    else if (formObj && formObj.value && !formObj.controls) {
      valuePresent = true;
    }
    else if (formObj && !formObj.value) {
      valuePresent = false;
    }
    else {
      valuePresent = false;
    }
    return valuePresent;
  }
}
